import Vue from 'vue';
import store from 'store';

export default (el) =>
  new Vue({
    components: {
      'product-card': () => import('../product-card/product-card.vue'),
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    store,
    el,
  });
